﻿import React from 'react';
import Lottie from 'lottie-react';


// utils
import useIntersection from '../../../CustomHooks/useIntersection';
import { getEpiData } from '../../../Utils/epiHelpers';
import RawHtml from '../../../UI/RawHtml';

// data
import iconAnimData from '../../../AnimationFiles/letter.json';

const AnimatedUspTeaserSchoolDirectorsEnvelope = (props) => {

    const text = getEpiData('text', props.mountRootId) || '';
    const linkText = getEpiData('link-text', props.mountRootId) || '';
    const link = getEpiData('link', props.mountRootId) || '';
    const heading = getEpiData('heading', props.mountRootId) || '';
    let color = getEpiData('color', props.mountRootId) || '';
    color = color.toLowerCase();

    const lottieRef = React.useRef();
    const teaserRef = React.useRef();
    const inViewport = useIntersection(teaserRef, "-50px");

    React.useEffect(() => {
        if (inViewport === true) {
            if (lottieRef && lottieRef.current) {
                lottieRef.current.play();
            }
        } else {
            if (lottieRef && lottieRef.current) {
                lottieRef.current.pause();
            }
        }
    }, [teaserRef, inViewport])
  
    return (
        <div className={`animated-usp-teaser teaser--${color} block-spacing`} ref={teaserRef}>
            <Lottie
                className="animated-usp-teaser__animation"
                autoplay={false}
                loop={false}
                animationData={iconAnimData}
                lottieRef={lottieRef}
            />
            <div className="animated-usp-teaser__content">
                {heading &&
                    <h2 className="animated-usp-teaser__content__title">
                        {heading}
                    </h2>
                } 
                <RawHtml className="animated-usp-teaser__content__content">{text}</RawHtml>
                <a className="button button--usp" href={link}>
                    <span>{linkText}</span>
                </a>
            </div>
        </div> 
     )
}

export default AnimatedUspTeaserSchoolDirectorsEnvelope;

